/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { Box } from "@mui/system";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { crudDe } from "../../../services/acesso";
import api from "../../../services/api";
import { FiTruck } from "react-icons/fi";
import { Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import Listagem, { AcaoEmLote, ConfiguracaoFiltros } from "../../../components/listagem";
import { useAppSelector } from "../../../store/hooks";
import ModalForm from "../../../components/modal-form";
import { useCallback, useEffect, useState, useMemo } from "react";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { TipoFormulario } from "../../../services/constantes";
import { ApiError, Campo, Opcao, PlanoManutencao, StatusPlanoManutencao } from "../../../services/tipos";
import { obterIdTenent, usuarioTemPermissao } from "../../../services/seguranca";
import { useFiliais } from "../../../hooks/useFiliais";
import { FaBell, FaCalendarCheck, FaCarSide, FaCheck, FaCheckCircle, FaCog, FaEdit, FaListUl, FaMotorcycle, FaRedo, FaTag, FaThLarge, FaTools, FaTrash, FaWhatsapp, FaWrench } from "react-icons/fa";
import { showButtonList } from "../../../components/button-list";
import { confirm } from "../../../components/confirm";

function PlanoManutencaoListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial, labelComFilial } = useFiliais();
    const navigate = useHistory();
    const location = useLocation();
    const token = useAppSelector(state => state.token);

    const [carregando, setCarregando] = useState(true);
    const [integradoRastreador, setIntegradoRastreador] = useState<boolean | null>(null);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [planos, setPlanos] = useState<PlanoManutencao[]>([]);
    const [realizarConsulta, setRealizarConsulta] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [planoSelecionado, setPlanoSelecionado] = useState<PlanoManutencao>({} as PlanoManutencao);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);

    const [mensagemWhatsAppManutencao, setMensagemWhatsAppManutencao] = useState<string>("");
    const [veiculosOptions, setVeiculosOptions] = useState<Opcao[]>([]);
    const [veiculosRaw, setVeiculosRaw] = useState<any[]>([]);
    const [filialNoForm, setFilialNoForm] = useState<string | null>(null);
    const [pecasData, setPecasData] = useState<any[]>([]);
    const [servicosData, setServicosData] = useState<any[]>([]);
    const [carregandoSelect, setCarregandoSelect] = useState(false);

    // SelectGrid state
    const [pecasSelecionadas, setPecasSelecionadas] = useState<any[]>([]);
    const [servicosSelecionados, setServicosSelecionados] = useState<any[]>([]);
    const [forcarAtualizacaoGrid, setForcarAtualizacaoGrid] = useState(false);

    const [tipoCriacao, setTipoCriacao] = useState<'simples' | 'detalhado'>('simples');
    const [tipoItem, setTipoItem] = useState<'peca' | 'servico'>('peca');

    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState(0);

    // Filtros
    const [idVeiculoFiltro, setIdVeiculoFiltro] = useState<string>("");
    const [idItemFiltro, setIdItemFiltro] = useState<string>("");
    const [statusFiltro, setStatusFiltro] = useState<(string | number | boolean)[]>(["0", "1", "2"]);
    const [recorrenteFiltro, setRecorrenteFiltro] = useState<string>("");

    // Criacao em lote (vinda da tela de manutenção)
    const [exibirFormLote, setExibirFormLote] = useState(false);
    const [loteVeiculoId, setLoteVeiculoId] = useState<string>("");
    const [loteHodometro, setLoteHodometro] = useState<number>(0);
    const [lotePecas, setLotePecas] = useState<{ id: string; nome: string }[]>([]);
    const [lotePecasIntervalo, setLotePecasIntervalo] = useState<{ [idPeca: string]: number }>({});

    const statusOptions = [
        { label: "Em dia", value: "0" },
        { label: "Próximo", value: "1" },
        { label: "Vencido", value: "2" },
        { label: "Concluído", value: "3" },
    ];

    const formatarDistancia = (valorKm: number) => {
        if (Math.abs(valorKm) < 1) {
            const metros = Math.round(valorKm * 1000);
            return `${metros.toLocaleString('pt-BR')} m`;
        }
        return `${valorKm.toLocaleString('pt-BR')} km`;
    };

    const getStatusBadge = (status: number) => {
        switch (status) {
            case StatusPlanoManutencao.EmDia: return { text: "Em dia", color: "#4CAF50" };
            case StatusPlanoManutencao.Proximo: return { text: "Próximo", color: "#F57F17" };
            case StatusPlanoManutencao.Vencido: return { text: "Vencido", color: "#f44336" };
            case StatusPlanoManutencao.Concluido: return { text: "Concluído", color: "#9E9E9E" };
            default: return { text: "Desconhecido", color: "#9E9E9E" };
        }
    };

    const colunas = useMemo(() => [
        {
            field: 'veiculo', headerName: 'Veículo', flex: 1.5,
            renderCell: (params: any) => {
                const veiculo = params.row.veiculo;
                if (!veiculo) return null;
                const icon = Number(veiculo?.tipoVeiculo) === 2 ? <FaMotorcycle size={16} /> : Number(veiculo?.tipoVeiculo) === 4 ? <FiTruck size={16} /> : <FaCarSide size={16} />;
                return (
                    <Box display="flex" flexDirection="column" py={0.5}>
                        <Box display="flex" alignItems="center" gap={1}>{icon}<Typography variant="body2" fontWeight={500}>{veiculo.placa}</Typography></Box>
                        <Box display="flex" alignItems="center" gap={1}><FaTag size={14} /><Typography variant="body2">{veiculo.marca} {veiculo.modelo}</Typography></Box>
                    </Box>
                );
            },
            valueGetter: (params: any) => `${params.row.veiculo?.placa} - ${params.row.veiculo?.marca} ${params.row.veiculo?.modelo}`
        },
        {
            field: 'item', headerName: 'Item', flex: 1,
            renderCell: (params: any) => {
                const peca = params.row.peca;
                const servico = params.row.servico;
                const nome = peca?.nome || servico?.nome;
                const tipo = peca ? 'Peça' : servico ? 'Serviço' : '';
                if (!nome) return null;
                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        {peca ? <FaCog size={14} /> : <FaWrench size={14} />}
                        <Typography variant="body2">{nome}</Typography>
                        <Typography variant="caption" color="textSecondary">({tipo})</Typography>
                    </Box>
                );
            },
            valueGetter: (params: any) => params.row.peca?.nome || params.row.servico?.nome || ''
        },
        {
            field: 'intervaloKm', headerName: 'Intervalo (km)', flex: 0.7,
            renderCell: (params: any) => <Typography variant="body2">{formatarDistancia(Number(params.value))}</Typography>
        },
        {
            field: 'kmRestantes', headerName: 'Km Restantes', flex: 0.7,
            renderCell: (params: any) => {
                const valor = Number(params.value);
                const status = params.row.status;
                if (status === StatusPlanoManutencao.Concluido) return <Typography variant="body2" color="textSecondary">-</Typography>;
                return <Typography variant="body2" style={{ color: valor <= 0 ? '#f44336' : valor <= params.row.intervaloKm * 0.2 ? '#FFC107' : '#4CAF50', fontWeight: 600 }}>{formatarDistancia(valor)}</Typography>;
            }
        },
        {
            field: 'status', headerName: 'Status', flex: 0.8,
            renderCell: (params: any) => {
                const badge = getStatusBadge(params.value);
                return <span style={{ backgroundColor: badge.color, color: 'white', padding: '5px 10px', borderRadius: '5px', fontWeight: 'bold', textAlign: 'center' }}>{badge.text}</span>;
            }
        },
        ...(empresaTemFiliais ? [{
            field: 'idFilial', headerName: 'Unidade', flex: 1,
            renderCell: (params: any) => {
                if (!params.value) return '';
                const filial = filiaisOptions.find((f: any) => f.valor === params.value);
                return filial?.label || '';
            }
        }] : []),
    ], [empresaTemFiliais, filiaisOptions]);

    // ── SelectGrid handlers ─────────────────────────────────────────
    const handlePecasChange = useCallback((data: any) => {
        setPecasSelecionadas(data);
    }, []);

    const handleServicosChange = useCallback((data: any) => {
        setServicosSelecionados(data);
    }, []);

    // ── Campos / Pages ──────────────────────────────────────────────
    const pages = useMemo(() => {
        if (modo === TipoFormulario.tpCadastro && tipoCriacao === 'detalhado') {
            return [
                { titulo: "Veículo", campos: ["idVeiculo", "hodometroUltimaExecucao"] },
                { titulo: "Peças", campos: ["pecasGrid"] },
                { titulo: "Serviços", campos: ["servicosGrid"] },
                { titulo: "Configurações", campos: ["recorrente", "observacao", "idFilial"] },
            ];
        }
        if (modo === TipoFormulario.tpCadastro && tipoCriacao === 'simples') {
            return [
                { titulo: "Veículo", campos: ["idVeiculo", "hodometroUltimaExecucao", "hodometroAtualVeiculo"] },
                { titulo: "Item", campos: ["tipoItemToggle", "idItem", "intervaloKm", "proximaTrocaKm"] },
                { titulo: "Configurações", campos: ["recorrente", "observacao", "idFilial"] },
            ];
        }
        return [
            { titulo: "Veículo", campos: ["idVeiculo", "hodometroUltimaExecucao", "hodometroAtualVeiculo"] },
            { titulo: "Item", campos: ["tipoItemToggle", "idItem", "intervaloKm", "proximaTrocaKm"] },
            { titulo: "Configurações", campos: ["recorrente", "observacao", "idFilial"] },
        ];
    }, [modo, tipoCriacao]);

    const pecasOptions = useMemo(() => pecasData.map((p: any) => ({ codigo: p.id, valor: p.id, label: p.nome })), [pecasData]);
    const servicosOptions = useMemo(() => servicosData.map((s: any) => ({ codigo: s.id, valor: s.id, label: s.nome })), [servicosData]);
    const itemOptions = useMemo(() => tipoItem === 'peca' ? pecasOptions : servicosOptions, [tipoItem, pecasOptions, servicosOptions]);

    const [intervaloModal, setIntervaloModal] = useState<number>(0);
    const [hodometroUltExecModal, setHodometroUltExecModal] = useState<number>(0);
    const proximaTrocaModal = hodometroUltExecModal + intervaloModal;

    // Filtra veículos pelo filial selecionado no formulário
    const veiculosOptionsFiltrados = filialNoForm
        ? veiculosRaw.filter((v: any) => !v.idFilial || v.idFilial === filialNoForm).map((v: any) => ({
            codigo: v.id, valor: v.id,
            label: labelComFilial(`${v.placa}: ${v.marca} ${v.modelo}`, v.idFilial),
        }))
        : veiculosOptions;

    const campos: Campo[] = useMemo(() => [
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 1, visible: true,
            opcoes: veiculosOptionsFiltrados, carregando: carregandoSelect,
            onCampoDigitar: (e: any) => {
                if (e && modo === TipoFormulario.tpCadastro) {
                    const label = veiculosOptions.find(v => v.valor === e)?.label || '';
                    const placa = label.split(':')[0]?.trim();
                    if (placa) {
                        api.get(`/AzulMonitor/Odometro/${obterIdTenent(token)}/${placa.replace('-', '').toUpperCase()}`)
                            .then(res => {
                                if (res.data?.encontrado && res.data?.odometroKm > 0) {
                                    setHodometroUltExecModal(res.data.odometroKm);
                                    setEntidadeParaAtualizarNoModal({ hodometroUltimaExecucao: res.data.odometroKm, hodometroAtualVeiculo: res.data.odometroKm });
                                    setForcarAtualizacaoDeEntidadeNoModal(prev => prev + 1);
                                }
                            })
                            .catch(() => { });
                    }
                }
            },
        },
        {
            label: 'Km da última troca', nome: 'hodometroUltimaExecucao', required: true, tipo: 'number', largura: 6, coluna: 1, linha: 2, visible: true,
            ajudinha: { texto: "Informe o hodômetro do veículo no momento em que a última manutenção deste item foi realizada. A partir desse valor + o intervalo, o sistema calcula quando será a próxima troca.", autoCloseTime: 5 },
            onCampoDigitar: (e: any) => { setHodometroUltExecModal(Number(e) || 0); }
        },
        {
            label: 'Km atual do veículo', nome: 'hodometroAtualVeiculo', required: false, tipo: 'number', largura: 6, coluna: 2, linha: 2,
            visible: modo !== TipoFormulario.tpCadastro || tipoCriacao === 'simples', apenasLeitura: true,
            ajudinha: { texto: "Hodômetro atual do veículo, obtido automaticamente pelo rastreador (Agillock) quando disponível. Usado para calcular os km restantes até a próxima troca.", autoCloseTime: 5 },
        },
        // SelectGrids (criação)
        {
            label: 'Peças', nome: 'pecasGrid', required: false, tipo: 'selectgrid', largura: 12, coluna: 1, linha: 3, visible: modo === TipoFormulario.tpCadastro && tipoCriacao === 'detalhado',
            ajudinha: { texto: "Adicione as peças que deseja monitorar. Para cada peça, defina o intervalo em km entre trocas. Cada peça gerará um plano individual.", autoCloseTime: 5 },
            selectGridProps: {
                dataSource: pecasData,
                onDataSourceChange: handlePecasChange,
                optionLabelField: 'nome',
                columns: [
                    { label: 'Peça', value: 'nome', editable: false, modalField: { linha: 1, label: "Peça", tipo: "text", coluna: 1, largura: 12, nome: "nome", required: false, apenasLeitura: true } },
                    { label: 'Intervalo (km)', value: 'intervaloKm', editable: true, type: "decimal", modalField: { linha: 2, label: "Intervalo (km)", tipo: "number", coluna: 1, largura: 6, nome: "intervaloKm", required: true } },
                ],
                initialGridData: pecasSelecionadas,
                height: '280px',
                modo: modo,
                forceUpdate: forcarAtualizacaoGrid,
                setData: pecasSelecionadas,
                modalTitle: "Adicionar Peça",
                modalSaveButtonText: "Adicionar"
            }
        },
        {
            label: 'Serviços', nome: 'servicosGrid', required: false, tipo: 'selectgrid', largura: 12, coluna: 1, linha: 3, visible: modo === TipoFormulario.tpCadastro && tipoCriacao === 'detalhado',
            ajudinha: { texto: "Adicione os serviços que deseja monitorar. Para cada serviço, defina o intervalo em km entre execuções.", autoCloseTime: 5 },
            selectGridProps: {
                dataSource: servicosData,
                onDataSourceChange: handleServicosChange,
                optionLabelField: 'nome',
                columns: [
                    { label: 'Serviço', value: 'nome', editable: false, modalField: { linha: 1, label: "Serviço", tipo: "text", coluna: 1, largura: 12, nome: "nome", required: false, apenasLeitura: true } },
                    { label: 'Intervalo (km)', value: 'intervaloKm', editable: true, type: "decimal", modalField: { linha: 2, label: "Intervalo (km)", tipo: "number", coluna: 1, largura: 6, nome: "intervaloKm", required: true } },
                ],
                initialGridData: servicosSelecionados,
                height: '280px',
                modo: modo,
                forceUpdate: forcarAtualizacaoGrid,
                setData: servicosSelecionados,
                modalTitle: "Adicionar Serviço",
                modalSaveButtonText: "Adicionar"
            }
        },
        // Toggle Peça / Serviço + select filtrado
        {
            label: '', nome: 'tipoItemToggle', required: false, tipo: 'toggle', largura: 12, coluna: 1, linha: 3,
            visible: modo !== TipoFormulario.tpCadastro || tipoCriacao === 'simples',
            defaultValueToggle: 'peca',
            opcoes: [{ label: "Peça", valor: "peca" }, { label: "Serviço", valor: "servico" }],
            onCampoDigitar: (e: any) => { setTipoItem(e === 'servico' ? 'servico' : 'peca'); }
        },
        {
            label: tipoItem === 'peca' ? 'Peça' : 'Serviço', nome: 'idItem', required: true, tipo: 'select', largura: 6, coluna: 1, linha: 4,
            visible: modo !== TipoFormulario.tpCadastro || tipoCriacao === 'simples', opcoes: itemOptions, carregando: carregandoSelect,
            ajudinha: { texto: "Selecione o item que deseja monitorar. O sistema acompanhará o desgaste com base no hodômetro e avisará quando estiver próximo ou vencido.", autoCloseTime: 5 },
        },
        {
            label: 'A cada quantos km?', nome: 'intervaloKm', required: true, tipo: 'number', largura: 6, coluna: 2, linha: 4,
            visible: modo !== TipoFormulario.tpCadastro || tipoCriacao === 'simples',
            ajudinha: { texto: "De quantos em quantos quilômetros esta manutenção deve ser realizada. Ex: troca de óleo a cada 5.000 km.", autoCloseTime: 5 },
            onCampoDigitar: (e: any) => { setIntervaloModal(Number(e) || 0); }
        },
        {
            label: 'Próxima troca prevista (km)', nome: 'proximaTrocaKm', required: false, tipo: 'number', largura: 6, coluna: 1, linha: 5,
            visible: modo !== TipoFormulario.tpCadastro || tipoCriacao === 'simples',
            ajudinha: { texto: "Calculado automaticamente: km da última troca + intervalo. Na edição, você pode forçar um valor manualmente — o sistema recalcula o km da última troca.", autoCloseTime: 5 },
            apenasLeitura: modo !== TipoFormulario.tpEdicao,
            onCampoDigitar: (e: any) => {
                const novaProximaTroca = Number(e) || 0;
                const novoHodUltExec = novaProximaTroca - intervaloModal;
                setHodometroUltExecModal(novoHodUltExec);
                setEntidadeParaAtualizarNoModal({ hodometroUltimaExecucao: novoHodUltExec });
                setForcarAtualizacaoDeEntidadeNoModal(prev => prev + 1);
            }
        },
        {
            label: 'Recorrente', nome: 'recorrente', required: false, tipo: 'toggle', largura: 6, coluna: 1, linha: 6, visible: true,
            ajudinha: { texto: "Se ativado, ao marcar como feito o plano reinicia a contagem a partir do hodômetro atual. Se desativado, o plano será concluído definitivamente.", autoCloseTime: 5 },
        },
        {
            label: 'Observação', nome: 'observacao', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 7, visible: true,
        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 7, visible: false },
        ...(getCampoFilial({ linha: 8, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) }) ? [getCampoFilial({ linha: 8, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) })!] : []),
    ], [veiculosOptions, veiculosOptionsFiltrados, pecasData, servicosData, itemOptions, carregandoSelect, modo, tipoCriacao, tipoItem, intervaloModal, hodometroUltExecModal, pecasSelecionadas, servicosSelecionados, forcarAtualizacaoGrid]);

    // ── Carregar selects ───────────────────────────────────────────
    useEffect(() => {
        const fetchOptions = async () => {
            setCarregandoSelect(true);
            try {
                const [veiculosRes, pecasRes, servicosRes, configRes] = await Promise.all([
                    api.get(`/VeiculoPorEmpresa/${obterIdTenent(token)}`),
                    api.get(`/PecaPorEmpresa/${obterIdTenent(token)}`),
                    api.get(`/ServicoPorEmpresa/${obterIdTenent(token)}`),
                    api.get('ConfiguracaoFilial/ResolvidaAtual').catch(() => ({ data: null }))
                ]);

                const possuiIntegracao = !!(configRes.data?.azulMonitorConfigurado);
                setIntegradoRastreador(possuiIntegracao);

                if (!possuiIntegracao) {
                    setCarregando(false);
                    return;
                }

                if (configRes.data?.mensagemWhatsAppManutencao) {
                    setMensagemWhatsAppManutencao(configRes.data.mensagemWhatsAppManutencao);
                }

                // Verificar quais veículos estão integrados ao rastreador
                const placas = veiculosRes.data.map((v: any) => v.placa).filter(Boolean);
                let placasRastreadas = new Set<string>();
                try {
                    const statusRes = await api.post(`/AzulMonitor/VerificarPlacas/${obterIdTenent(token)}`, placas);
                    placasRastreadas = new Set(
                        (statusRes.data || []).filter((s: any) => s.rastreada).map((s: any) => s.placa)
                    );
                } catch { /* rastreador não configurado */ }

                const veiculosFiltradosPorRastreador = veiculosRes.data.filter((v: any) => placasRastreadas.has(v.placa));
                setVeiculosRaw(veiculosFiltradosPorRastreador);
                setVeiculosOptions(
                    veiculosFiltradosPorRastreador.map((v: any) => ({
                            codigo: v.id, valor: v.id,
                            label: labelComFilial(`${v.placa}: ${v.marca} ${v.modelo}`, v.idFilial),
                        }))
                );

                setPecasData(pecasRes.data.map((p: any) => ({
                    ...p, intervaloKm: p.vidaUtilEmKm || 5000,
                })));

                setServicosData(servicosRes.data.map((s: any) => ({
                    ...s, intervaloKm: s.periodoEmKm || 5000,
                })));
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregandoSelect(false);
            }
        };

        fetchOptions();
    }, []);

    // Verificar params de criação em lote (vindos da tela de manutenção)
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const criar = params.get('criar');
        const idVeiculo = params.get('idVeiculo');
        const hodometro = params.get('hodometro');
        const pecasParam = params.get('pecas');

        if (criar === 'true' && idVeiculo && pecasParam) {
            try {
                const pecasParsed = JSON.parse(pecasParam);
                setLoteVeiculoId(idVeiculo);
                setLoteHodometro(Number(hodometro) || 0);
                setLotePecas(pecasParsed);

                const intervalos: { [key: string]: number } = {};
                pecasParsed.forEach((p: any) => { intervalos[p.id] = p.vidaUtilEmKm || 5000; });
                setLotePecasIntervalo(intervalos);
                setExibirFormLote(true);

                navigate.replace('/plano-manutencao');
            } catch { }
        }
    }, [location.search]);

    useEffect(() => {
        if (forcarAtualizacaoGrid) setForcarAtualizacaoGrid(false);
    }, [forcarAtualizacaoGrid]);

    useEffect(() => {
        if (exibirFormModal && (modo !== TipoFormulario.tpCadastro || tipoCriacao === 'simples')) {
            setEntidadeParaAtualizarNoModal({ proximaTrocaKm: proximaTrocaModal });
            setForcarAtualizacaoDeEntidadeNoModal(prev => prev + 1);
        }
    }, [proximaTrocaModal, exibirFormModal, modo, tipoCriacao]);

    const temPermissao = useMemo(() => usuarioTemPermissao(token, 'servicoveiculo_visualizar'), [token]);

    const tratarErro = useCallback((error: AxiosError<ApiError>) => {
        setCarregando(false);
        setIsSubmiting(false);
        toast.error(`Não foi possível continuar a operação: ${(error.response?.data?.Mensagem || 'Erro desconhecido')}`);
    }, []);

    // ── Buscar planos (paginado, server-side) ─────────────────────
    useEffect(() => {
        const fetchData = async () => {
            if (temPermissao && realizarConsulta) {
                setCarregando(true);
                try {
                    // Montar filtro de status: envia lista ao backend para filtrar server-side
                    let statusList: number[] | undefined = undefined;
                    if (Array.isArray(statusFiltro) && statusFiltro.length > 0 && statusFiltro.length < 4) {
                        statusList = statusFiltro.map(s => Number(s));
                    }

                    const response = await api.post(`/PlanoManutencao/Listar`, {
                        page: paginationModel.page + 1,
                        pageSize: paginationModel.pageSize,
                        idEmpresa: obterIdTenent(token),
                        idVeiculo: idVeiculoFiltro || undefined,
                        idItem: idItemFiltro || undefined,
                        statusList,
                        recorrente: recorrenteFiltro !== "" ? recorrenteFiltro === "true" : undefined,
                    });
                    const items = response.data.items || [];
                    const total = response.data.totalCount || 0;

                    setPlanos(items);
                    setTotalCount(total);
                } catch (error) {
                    tratarErro(error as AxiosError<ApiError>);
                } finally {
                    setCarregando(false);
                    setRealizarConsulta(false);
                }
            }
        };
        fetchData();
    }, [temPermissao, realizarConsulta, token, paginationModel]);

    // Disparar re-consulta quando filtros mudam
    useEffect(() => {
        setPaginationModel(prev => ({ ...prev, page: 0 }));
        setRealizarConsulta(true);
    }, [idVeiculoFiltro, idItemFiltro, statusFiltro, recorrenteFiltro]);

    // ── Handlers ────────────────────────────────────────────────────
    const handleFecharModal = useCallback(() => {
        setExibirFormModal(false);
        if (fezAlgumaAcao) { setRealizarConsulta(true); setFezAlgumaAcao(false); }
    }, [fezAlgumaAcao]);

    const abrirModalCriacao = useCallback((tipo: 'simples' | 'detalhado') => {
        setTipoCriacao(tipo);
        setTipoItem('peca');
        setPecasSelecionadas([]);
        setServicosSelecionados([]);
        setHodometroUltExecModal(0);
        setIntervaloModal(0);
        setForcarAtualizacaoGrid(true);
        setEntidadeParaAtualizarNoModal({ recorrente: true, hodometroUltimaExecucao: 0, hodometroAtualVeiculo: 0, proximaTrocaKm: 0, tipoItemToggle: 'peca' });
        setForcarAtualizacaoDeEntidadeNoModal(prev => prev + 1);
        setModo(TipoFormulario.tpCadastro);
        setPlanoSelecionado({} as PlanoManutencao);
        setExibirFormModal(true);
    }, []);

    const handleCadastrar = useCallback(async () => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_novo')) { toast.error('Você não tem permissão'); return; }

        await showButtonList({
            title: "Novo Plano de Manutenção",
            message: "Escolha o tipo de plano que deseja criar",
            buttons: [
                {
                    icon: <FaListUl />,
                    title: "Simples",
                    description: "Uma peça ou serviço com intervalo, hodômetro e próxima troca",
                    onClick: () => abrirModalCriacao('simples'),
                },
                {
                    icon: <FaThLarge />,
                    title: "Detalhado",
                    description: "Múltiplas peças e serviços de uma vez, cada um com seu intervalo",
                    onClick: () => abrirModalCriacao('detalhado'),
                }
            ]
        });
    }, [token, abrirModalCriacao]);

    const handleEditar = useCallback((plano: any) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_editar')) { toast.error('Você não tem permissão'); return; }
        const hodAtual = plano.hodometroAtual || plano.veiculo?.hodometro || 0;
        const hodUltExec = Number(plano.hodometroUltimaExecucao) || 0;
        const intervalo = Number(plano.intervaloKm) || 0;
        const ehPeca = !!plano.idPeca;
        setTipoItem(ehPeca ? 'peca' : 'servico');
        setHodometroUltExecModal(hodUltExec);
        setIntervaloModal(intervalo);
        setModo(TipoFormulario.tpEdicao);
        setPlanoSelecionado({ ...plano, hodometroAtualVeiculo: hodAtual, proximaTrocaKm: hodUltExec + intervalo, idItem: plano.idPeca || plano.idServico, tipoItemToggle: ehPeca ? 'peca' : 'servico' });
        setExibirFormModal(true);
    }, [token]);

    const handleExclusao = useCallback(async (plano: PlanoManutencao) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_excluir')) return;
        if (await confirm("Deseja realmente excluir este Plano de Manutenção?")) {
            setCarregando(true);
            try {
                await api.delete(`/PlanoManutencao/${plano.id}`);
                toast.success('Plano excluído com sucesso');
                setRealizarConsulta(true);
            } catch (error) { tratarErro(error as AxiosError<ApiError>); }
            finally { setCarregando(false); }
        }
    }, [token]);

    const handleVisualizacao = useCallback((plano: any) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_visualizar')) return;
        const hodAtual = plano.hodometroAtual || plano.veiculo?.hodometro || 0;
        const hodUltExec = Number(plano.hodometroUltimaExecucao) || 0;
        const intervalo = Number(plano.intervaloKm) || 0;
        const ehPeca = !!plano.idPeca;
        setTipoItem(ehPeca ? 'peca' : 'servico');
        setHodometroUltExecModal(hodUltExec);
        setIntervaloModal(intervalo);
        setPlanoSelecionado({ ...plano, hodometroAtualVeiculo: hodAtual, proximaTrocaKm: hodUltExec + intervalo, idItem: plano.idPeca || plano.idServico, tipoItemToggle: ehPeca ? 'peca' : 'servico' });
        setExibirFormModal(true);
        setModo(TipoFormulario.tpVisualizacao);
    }, [token]);

    const handleMarcarComoFeito = useCallback(async (plano: PlanoManutencao) => {
        const nomeItem = plano.peca?.nome || plano.servico?.nome || '';
        await showButtonList({
            title: "Marcar como feito",
            message: `${plano.veiculo?.placa} - ${nomeItem}`,
            buttons: [
                {
                    icon: <FaRedo />, title: "Recorrente (reiniciar)", description: "Atualiza o hodômetro e reinicia a contagem",
                    onClick: async () => {
                        try { await api.put(`/PlanoManutencao/MarcarComoFeito/${plano.id}`, { recorrente: true, hodometroAtual: plano.hodometroAtual }); toast.success('Plano reiniciado'); setRealizarConsulta(true); }
                        catch (error) { tratarErro(error as AxiosError<ApiError>); }
                    }
                },
                {
                    icon: <FaCheck />, title: "Concluir plano", description: "Marca como concluído definitivamente",
                    onClick: async () => {
                        try { await api.put(`/PlanoManutencao/MarcarComoFeito/${plano.id}`, { recorrente: false, hodometroAtual: plano.hodometroAtual }); toast.success('Plano concluído'); setRealizarConsulta(true); }
                        catch (error) { tratarErro(error as AxiosError<ApiError>); }
                    }
                }
            ]
        });
    }, []);

    const handleRealizarManutencao = useCallback((plano: PlanoManutencao) => {
        const params = new URLSearchParams();
        if (plano.idVeiculo) params.set('idVeiculo', plano.idVeiculo);
        if (plano.hodometroAtual) params.set('hodometro', String(plano.hodometroAtual));
        if (plano.idPeca) params.set('idPeca', plano.idPeca);
        if (plano.id) params.set('planoManutencaoId', plano.id);
        window.open(`/manutencoes?${params.toString()}`, '_blank');
    }, []);

    const handleFalarComLocatario = useCallback((plano: PlanoManutencao) => {
        if (!plano.telefoneLocatario) {
            toast.error('Este veículo não possui locatário com telefone cadastrado.');
            return;
        }

        const telefone = plano.telefoneLocatario.replace(/\D/g, '');
        const placa = plano.veiculo?.placa || '';
        const item = plano.peca?.nome || plano.servico?.nome || '';
        const statusLabel = plano.status === 2 ? 'vencida' : plano.status === 1 ? 'próxima do vencimento' : 'programada';
        const kmInfo = plano.status === 2
            ? `${Math.abs(plano.kmRestantes).toLocaleString('pt-BR')} km além do previsto`
            : `faltam ${plano.kmRestantes.toLocaleString('pt-BR')} km`;

        const mensagemDefault = `Olá ${plano.nomeLocatario || ''}! Informamos que a manutenção do veículo *${placa}* está *${statusLabel}*. Item: *${item}*. Situação: ${kmInfo}. Por favor, entre em contato para agendarmos a manutenção.`;

        let textoFinal = mensagemDefault;
        if (mensagemWhatsAppManutencao) {
            textoFinal = mensagemWhatsAppManutencao
                .replace(/\{nome_locatario\}/g, plano.nomeLocatario || '')
                .replace(/\{placa\}/g, placa)
                .replace(/\{item\}/g, item)
                .replace(/\{status\}/g, statusLabel)
                .replace(/\{km_info\}/g, kmInfo);
        }

        window.open(`https://wa.me/55${telefone}?text=${encodeURIComponent(textoFinal)}`, '_blank');
    }, [mensagemWhatsAppManutencao]);

    const handleNotificarNoApp = useCallback(async (plano: PlanoManutencao) => {
        if (!plano.id) return;
        try {
            await api.post('/PlanoManutencao/NotificarLocatario', { idPlano: plano.id });
            toast.success('Notificação enviada para o aplicativo do locatário!');
        } catch (error: any) {
            const msg = error.response?.data?.Mensagem || error.response?.data?.mensagem || 'Erro ao enviar notificação.';
            toast.error(msg);
        }
    }, []);

    // ── Save ────────────────────────────────────────────────────────
    const onSave = useCallback(async (entidade: any) => {
        if (isSubmiting) return;
        setIsSubmiting(true);

        try {
            if (modo === TipoFormulario.tpCadastro && tipoCriacao === 'detalhado') {
                // Detalhado: criar um plano por peça + um por serviço
                const itens: any[] = [];
                pecasSelecionadas.forEach((p: any) => {
                    itens.push({ idPeca: p.id, idServico: null, intervaloKm: Number(p.intervaloKm) || 5000 });
                });
                servicosSelecionados.forEach((s: any) => {
                    itens.push({ idPeca: null, idServico: s.id, intervaloKm: Number(s.intervaloKm) || 5000 });
                });

                if (itens.length === 0) { toast.error('Adicione pelo menos uma peça ou serviço'); setIsSubmiting(false); return; }

                await api.post('/PlanoManutencao/EmLote', {
                    idEmpresa: obterIdTenent(token),
                    idVeiculo: entidade.idVeiculo,
                    hodometro: Number(entidade.hodometroUltimaExecucao) || 0,
                    recorrente: entidade.recorrente === true || entidade.recorrente === 'true',
                    observacao: entidade.observacao || null,
                    idFilial: entidade.idFilial || null,
                    itens
                });

                toast.success(`${itens.length} plano(s) de manutenção criado(s)`);
            } else if (modo === TipoFormulario.tpCadastro && tipoCriacao === 'simples') {
                // Simples: criar um plano único
                const { hodometroAtualVeiculo, proximaTrocaKm, id, idItem, tipoItemToggle, ...rest } = entidade;
                const itemRef = tipoItem === 'peca' ? { idPeca: idItem, idServico: null } : { idPeca: null, idServico: idItem };

                await api.post('/PlanoManutencao', {
                    ...rest, ...itemRef,
                    idEmpresa: obterIdTenent(token),
                    dataCriacao: new Date().toISOString(),
                    recorrente: entidade.recorrente === true || entidade.recorrente === 'true',
                    concluido: false,
                    intervaloKm: Number(entidade.intervaloKm) || 0,
                    hodometroUltimaExecucao: Number(entidade.hodometroUltimaExecucao) || 0,
                    idFilial: entidade.idFilial || null,
                });

                toast.success('Plano de Manutenção criado com sucesso');
            } else {
                // Edição: item único
                const { hodometroAtualVeiculo, proximaTrocaKm, id, idItem, tipoItemToggle, ...rest } = entidade;
                const itemRef = tipoItem === 'peca' ? { idPeca: idItem, idServico: null } : { idPeca: null, idServico: idItem };

                await api.put('/PlanoManutencao', {
                    ...rest, ...itemRef,
                    idEmpresa: obterIdTenent(token),
                    dataCriacao: entidade.dataCriacao,
                    recorrente: entidade.recorrente === true || entidade.recorrente === 'true',
                    concluido: entidade.concluido === true || entidade.concluido === 'true',
                    intervaloKm: Number(entidade.intervaloKm) || 0,
                    hodometroUltimaExecucao: Number(entidade.hodometroUltimaExecucao) || 0,
                    idFilial: entidade.idFilial || null,
                    ...(id ? { id } : {}),
                });

                toast.success('Plano salvo com sucesso');
            }

            setRealizarConsulta(true);
            setExibirFormModal(false);
            setFezAlgumaAcao(true);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setIsSubmiting(false);
        }
    }, [isSubmiting, token, modo, tipoCriacao, tipoItem, pecasSelecionadas, servicosSelecionados]);

    const handleSalvarLote = useCallback(async () => {
        setIsSubmiting(true);
        try {
            const itens = lotePecas.map(p => ({ idPeca: p.id, intervaloKm: lotePecasIntervalo[p.id] || 5000 }));
            await api.post('/PlanoManutencao/EmLote', { idEmpresa: obterIdTenent(token), idVeiculo: loteVeiculoId, hodometro: loteHodometro, itens });
            toast.success(`${itens.length} plano(s) criado(s)`);
            setExibirFormLote(false);
            setRealizarConsulta(true);
        } catch (error) { tratarErro(error as AxiosError<ApiError>); }
        finally { setIsSubmiting(false); }
    }, [token, loteVeiculoId, loteHodometro, lotePecas, lotePecasIntervalo]);

    const requisicaoBemSucedida = useCallback(() => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        setFezAlgumaAcao(true);
    }, []);

    // ── Ações em Lote ────────────────────────────────────────────────
    const handleMarcarComoFeitoEmLote = useCallback(async (ids: (string | number)[], recorrente: boolean) => {
        const planosParaAcao = planos.filter(p => p.id && ids.includes(p.id));
        const label = recorrente ? "reiniciar" : "concluir";
        if (!await confirm(`Deseja ${label} ${planosParaAcao.length} plano(s) selecionado(s)?`)) return;

        setCarregando(true);
        let sucesso = 0;
        let erros = 0;
        await Promise.all(
            planosParaAcao.map(plano =>
                api.put(`/PlanoManutencao/MarcarComoFeito/${plano.id}`, { recorrente, hodometroAtual: plano.hodometroAtual || 0 })
                    .then(() => { sucesso++; })
                    .catch(() => { erros++; })
            )
        );
        setCarregando(false);
        if (sucesso > 0) toast.success(`${sucesso} plano(s) ${recorrente ? "reiniciado(s)" : "concluído(s)"} com sucesso.`);
        if (erros > 0) toast.error(`${erros} plano(s) falharam.`);
        setRealizarConsulta(true);
    }, [planos]);

    const handleExcluirEmLote = useCallback(async (ids: (string | number)[]) => {
        if (!await confirm(`Deseja excluir ${ids.length} plano(s) selecionado(s)?`)) return;

        setCarregando(true);
        let sucesso = 0;
        let erros = 0;
        await Promise.all(
            ids.map(id =>
                api.delete(`/PlanoManutencao/${id}`)
                    .then(() => { sucesso++; })
                    .catch(() => { erros++; })
            )
        );
        setCarregando(false);
        if (sucesso > 0) toast.success(`${sucesso} plano(s) excluído(s) com sucesso.`);
        if (erros > 0) toast.error(`${erros} plano(s) falharam ao excluir.`);
        setRealizarConsulta(true);
    }, []);

    const acoesEmLote: AcaoEmLote[] = useMemo(() => [
        { titulo: "Reiniciar (recorrente)", icone: FaRedo, cor: "#1F467E", onClick: (ids) => handleMarcarComoFeitoEmLote(ids, true) },
        { titulo: "Concluir", icone: FaCheck, cor: "#4CAF50", onClick: (ids) => handleMarcarComoFeitoEmLote(ids, false) },
        { titulo: "Excluir", icone: FaTrash, cor: "#e53935", onClick: (ids) => handleExcluirEmLote(ids) },
        ...(getAcaoEmLoteFilial('PlanoManutencao', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('PlanoManutencao', () => setRealizarConsulta(true))!] : []),
    ], [handleMarcarComoFeitoEmLote, handleExcluirEmLote]);

    const recorrenteOptions = [
        { label: "Recorrente", value: "true" },
        { label: "Não recorrente", value: "false" },
    ];

    const configFiltros: ConfiguracaoFiltros = {
        carregando,
        dropdowns: [
            { key: 'veiculo', label: 'Veículo', placeholder: 'Todos os veículos', multiSelect: false, opcoes: veiculosOptions.map(v => ({ label: v.label, value: v.valor })), value: idVeiculoFiltro, onChange: (val) => setIdVeiculoFiltro(val as string) },
            { key: 'item', label: 'Peça / Serviço', placeholder: 'Todos os itens', multiSelect: false, opcoes: [...pecasData.map((p: any) => ({ label: `${p.nome} (Peça)`, value: p.id })), ...servicosData.map((s: any) => ({ label: `${s.nome} (Serviço)`, value: s.id }))], value: idItemFiltro, onChange: (val) => setIdItemFiltro(val as string) },
            { key: 'status', label: 'Status', placeholder: 'Todos os status', multiSelect: true, opcoes: statusOptions, value: statusFiltro, onChange: (val) => setStatusFiltro(val as (string | number | boolean)[]) },
            { key: 'recorrente', label: 'Tipo', placeholder: 'Todos os tipos', multiSelect: false, opcoes: recorrenteOptions, value: recorrenteFiltro, onChange: (val) => setRecorrenteFiltro(val as string) },
        ]
    };

    if (integradoRastreador === false) {
        return (
            <LocaSmartLayout>
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh" gap={2} textAlign="center" px={2}>
                    <FaCalendarCheck size={64} color="#bdbdbd" />
                    <Typography variant="h5" fontWeight={600} color="textSecondary">
                        Plano de Manutenção
                    </Typography>
                    <Typography variant="body1" color="textSecondary" maxWidth={480}>
                        Necessária integração com a nossa Plataforma de Rastreio para utilizar o Plano de Manutenção.
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Configure a integração em <strong>Minha Conta &gt; Integrações &gt; Agillock</strong>.
                    </Typography>
                </Box>
            </LocaSmartLayout>
        );
    }

    return (
        <LocaSmartLayout>
            <Listagem
                permissoes={crudDe('servicoveiculo')}
                colunas={colunas}
                linhas={planos}
                nomeEntidade="Plano de Manutenção"
                nomePropriedade="observacao"
                carregando={carregando}
                IconeEntidade={FaCalendarCheck}
                exibirAcoesDeCrud={false}
                paginationMode="server"
                rowCount={totalCount}
                paginationModel={paginationModel}
                onPaginationModelChange={(model) => { setPaginationModel(model); setRealizarConsulta(true); }}
                acoesExtras={[
                    { Icone: FaCheckCircle, OnClick: handleMarcarComoFeito, Texto: "Marcar como feito", Tamanho: "medium" },
                    { Icone: FaWhatsapp, OnClick: handleFalarComLocatario, Texto: "Falar com Locatário", Tamanho: "medium" },
                    { Icone: FaBell, OnClick: handleNotificarNoApp, Texto: "Notificar no App", Tamanho: "medium" },
                    { Icone: FaTools, OnClick: handleRealizarManutencao, Texto: "Realizar Manutenção", Tamanho: "medium" },
                    { Icone: FaEdit, OnClick: handleEditar, Texto: "Editar", Tamanho: "medium" },
                    { Icone: FaTrash, OnClick: handleExclusao, Texto: "Excluir", Tamanho: "medium" },
                ]}
                handleEditar={handleEditar}
                handleCriar={handleCadastrar}
                handleExclusao={handleExclusao}
                handleVisualizacao={handleVisualizacao}
                handleSelecionarEntidade={setPlanoSelecionado}
                filtros={configFiltros}
                acoesEmLote={acoesEmLote}
            />

            <ModalForm
                modo={modo}
                tamanho="lg"
                campos={campos}
                onSave={onSave}
                show={exibirFormModal}
                isSaving={isSubmiting}
                carregando={carregando}
                onHide={handleFecharModal}
                onCancel={handleFecharModal}
                titulo={modo === TipoFormulario.tpCadastro ? "Novo Plano de Manutenção" : modo === TipoFormulario.tpEdicao ? "Editar Plano de Manutenção" : "Plano de Manutenção"}
                entidadeSelecionada={planoSelecionado}
                apiConfig={{ endpoint: 'PlanoManutencao', idTenentCampo: 'idEmpresa', requisicaoBemSucedida, tratarErro }}
                atualizacaoEntidade={{ entidadeUsadaParaAtualizacao: entidadeParaAtualizarNoModal, forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal }}
                pages={pages}
            />

            {/* Modal de criação em lote (vindo da manutenção) */}
            {exibirFormLote && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ background: 'white', borderRadius: '12px', padding: '24px', width: '90%', maxWidth: '600px', maxHeight: '80vh', overflow: 'auto' }}>
                        <h3 style={{ margin: '0 0 16px 0', color: '#1F467E' }}>Criar Planos de Manutenção</h3>
                        <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>Defina o intervalo em km para cada peça utilizada.</p>
                        {lotePecas.map((peca) => (
                            <div key={peca.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                                <FaCog size={16} color="#1F467E" />
                                <span style={{ flex: 1, fontWeight: 500 }}>{peca.nome}</span>
                                <input type="number" value={lotePecasIntervalo[peca.id] || ''} onChange={(e) => setLotePecasIntervalo(prev => ({ ...prev, [peca.id]: Number(e.target.value) }))} placeholder="Intervalo (km)" style={{ width: '140px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px' }} />
                                <span style={{ fontSize: '13px', color: '#888' }}>km</span>
                            </div>
                        ))}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <button onClick={() => setExibirFormLote(false)} style={{ padding: '10px 20px', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', background: '#f8f9fa' }}>Cancelar</button>
                            <button onClick={handleSalvarLote} disabled={isSubmiting} style={{ padding: '10px 20px', border: 'none', borderRadius: '8px', cursor: 'pointer', background: '#1F467E', color: 'white', fontWeight: 600 }}>{isSubmiting ? 'Salvando...' : 'Criar Planos'}</button>
                        </div>
                    </div>
                </div>
            )}
        </LocaSmartLayout>
    );
}

export default PlanoManutencaoListagem;
